import { useSelector } from 'react-redux'
import { getProfileState } from '@/profile/stores/store'

interface MenuProps {
  name: string
  icon: string
  link: string
  scopes?: String[]
  code: string
}

const PORTAL_PREFIX = '/user'
export const menu: MenuProps[] = [
  {
    icon: 'people_team_filled',
    name: 'User management',
    link: `${PORTAL_PREFIX}/user`,
    code: 'USER_MANAGEMENT'
  },
  {
    icon: 'service_bell_filled',
    name: 'Notification',
    link: `${PORTAL_PREFIX}/notification`,
    code: 'NOTIFICATION_MANAGEMENT'
  }
]

export const getMenu = () => {
  const profile = useSelector(getProfileState)
  const codeAccess = new Set<string>()
  profile?.roles?.forEach((role) => role.resources?.forEach((resource) => codeAccess.add(resource.code || '')))

  const filterMenu = menu.filter((item) => codeAccess.has(item.code))
  return filterMenu
}
